/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unstable-nested-components */
import React, { PropsWithChildren } from 'react';
import ReactMarkdown from 'react-markdown';
import { cn } from '@helpers/className';
import styles from './MarkdownHotelDescription.module.css';

export default function MarkdownHotelDescription({ children }: PropsWithChildren) {
  return (
    <div className={cn('font-rp-basetica', styles.markdown)}>
      <ReactMarkdown
        components={{
          ul(props) {
            const { node, ...rest } = props;
            return <ul className="list-disc list-outside text-14 space-y-spacing-md" {...rest} />;
          },
          li(props) {
            const { node, ...rest } = props;
            return (
              <li
                className="line-height leading-normal ml-spacing-md text-solar-secondary"
                {...rest}
              />
            );
          },
          strong(props) {
            const { node, ...rest } = props;
            return <strong className="font-normal text-solar-primary" {...rest} />;
          },
        }}
      >
        {children as string}
      </ReactMarkdown>
    </div>
  );
}
